import { branch, renderNothing } from 'recompose';
import { isActive } from '../service';

const hideForContainerApp = history => branch(
  () => isActive(history),
  renderNothing
);

export default hideForContainerApp;
